export default "__VITE_ASSET__e222fc18__"